import { api } from '@services/api';

const featureFlagsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getIsFlagEnabled: builder.query<
            { is_enabled: boolean },
            'AUTHORIZED_INSTALLER_PROGRAM' | 'EXTENDED_WARRANTY' | 'COMPANY_ENTITY'
        >({
            query: (flag) => `is-flag-enabled/${flag}/`,
            providesTags: (_res, _err, flag) => [{ type: 'Countries', id: flag }],
        }),
    }),
});

export const { useGetIsFlagEnabledQuery } = featureFlagsApi;
export default featureFlagsApi;
